import Cookies from "js-cookie";

export const PRODUCT = {
  SESSION: {
    COUPPON: "_coupon_",
    GAME_COUPPON: "_kcg_",
  },
};

export const removeGameCouponLocalStoreFlow = () => {
  sessionStorage.removeItem("_kcg_"); //ket qua code_gaming
  Cookies.remove("_cg_"); //code_gaming
  Cookies.remove("copied-code"); //action user copy code
};
export const removeItemCouponLocalStoreFlow = (codes?: string[]) => {
  if (codes && codes.length > 0) {
    sessionStorage.setItem("_cabh_", JSON.stringify(codes)) // apply multiple codes
  } else {
    sessionStorage.removeItem("_cabh_"); // codeAppliedByHand
  }
  sessionStorage.removeItem("_coupon_");
};
export const removeCouponLocalStoreFlow = (code?: string[]) => {
  console.log('🚀 ~ removeCouponLocalStoreFlow ~ code:', code);
  removeItemCouponLocalStoreFlow(code);
  removeGameCouponLocalStoreFlow();
};

export const VALUE_INTERNAL = "true";
